import React from "react";

const BS5_Exercises = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Exercises Component</h2>
      <p>This is the BS5_Exercises component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Exercises;
